import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { ChakraProvider } from '@chakra-ui/react';
import theme from './theme/theme';
import { ThemeEditorProvider } from '@hypertheme-editor/chakra-ui';
import i18n from './localization/i18n';
import App from './app';
import 'assets/css/App.css';
import 'react-toastify/dist/ReactToastify.css';

ReactDOM.render(
	<Provider store={store}>
		<BrowserRouter>
			<ChakraProvider theme={theme}>
				<React.StrictMode>
					{/* <ThemeEditorProvider> */}
					<App />
					{/* </ThemeEditorProvider> */}
				</React.StrictMode>
			</ChakraProvider>
		</BrowserRouter>
	</Provider>,
	document.getElementById('root')
);
